import { HomeOutlined } from "@ant-design/icons";
import ConectionLogo from "./Logo-conection";

const Logo: React.FC<any> = (props: { size: number }) => (
  <>
    <ConectionLogo />
  </>
);

export default Logo;
